import Cam4Api from "./api/Cam4Api";
import Flirt4FreeApi from "./api/Flirt4FreeApi";
import NullCamApi from "./api/NullCamApi";
import LiveJasminApi from "./api/LiveJasminApi";
import ImLiveApi from "./api/ImLiveApi";
import JerkmateApi from "./api/JerkmateApi";

const resolvers = new Map([
    ['cam4', config => new Cam4Api(config)],
    ['flirt4free', config => new Flirt4FreeApi(config)],
    ['livejasmin', config => new LiveJasminApi(config)],
    ['imlive', config => new ImLiveApi(config)],
    ['jerkmate', config => new JerkmateApi(config)],
    ['null', () => new NullCamApi()],
]);

/**
 * @param {object} config
 * @returns {BaseCamApi}
 */
export const resolveCamsApi = config => {
    const resolver = resolvers.get(config.provider || 'null') || resolvers.get('null');
    return resolver(config);
};
